import React, { useEffect, useContext } from "react"
import { AuthContext } from "../../contexts/auth/AuthContext"
import { usePermission } from "../../utils/hasPermission"

import { Layout, Button, message } from "antd"
import TableExtended, {
  ITableExtended,
} from "../../components/table/TableExtended"
import { useTranslation } from "react-i18next"
import { Search } from "react-feather"
import SEO from "../../containers/helpers/SEO"
import useQueryParams from "../../hooks/useQueryParams"
import { FunctionComponent } from "react"
import usePagination from "../../hooks/usePagination"

import isEmptyObj from "../../utils/isEmptyObj"
import { periodInterval, DefaultPeriod } from "../../utils/defaultPeriod"   // Tog'a #438: sukut «Сегодня»
import { IColumnType } from "../../types"
import { useQuery } from "@tanstack/react-query"

export interface IGroupedPage {
  name: string
  exportQueryName?: string
  singularName?: string
  collectionQuery: any
  where?: object
  filterComponent?: FunctionComponent<any>
  filterComponentProps?: any
  columns: IColumnType[]
  tableProps?: Partial<ITableExtended>
  queryVariables?: any
  disableDefaultWeeklyFilter?: boolean
  /** Tog'a #438: sukut davri (standart — «Сегодня»; qoldiqqa o'xshash ro'yxatlar «week» berishi mumkin) */
  defaultPeriod?: DefaultPeriod
  exportQuery?: any
  isDefective?: boolean
  // drawerProps?: DrawerProps;
  // drawerChild?: JSX.Element;
}

// export interface ICollectionNode {
//   id: number;
// }

function GroupedPage(props: IGroupedPage) {
  const title = props.singularName || props.name.slice(0, -1)
  const { t } = useTranslation()
  const { pageConfig } = usePagination(title)
  const query = useQueryParams()

  //mmm
  const {
    isLoading: loading,
    error,
    data,
    refetch,
  } = useQuery(
    [
      title,
      "props.collectionQuery",
      ...Object.values({
        ...pageConfig,
        ...(!isEmptyObj(props.queryVariables) && props.queryVariables),
      }),
    ],
    () =>
      props.collectionQuery({
        ...pageConfig,
        ...(!isEmptyObj(props.queryVariables) && props.queryVariables),
      })
    // {
    //   variables: {
    //     ...pageConfig,
    //     ...(!isEmptyObj(props.where) && { where: props.where }),
    //     ...(query.get(title + "orderBy") &&
    //       safeObj({ order: safeObj(query.get(title + "orderBy") as object) })),
    //     ...props.queryVariables,
    //   },
    //   pollInterval: 10000,
    // }
  )
  const {
    data: allData,
    refetch: refetchAllData,
    isFetching: loadingAllData,   // tog'a #309: o'chiq so'rovda isLoading doim true (react-query v4)
  } = useQuery(
    [
      title,
      "props.exportQuery",
      ...Object.values({ ...props.where, ...props.queryVariables }),
    ],
    () => props.exportQuery({ ...props.where, ...props.queryVariables }),
    // tog'a #309: «hamma yozuvlar» faqat server «Итого» bermagan bo'lsa oldindan; eksport o'zi kutib yuklaydi (Page bilan bir xil)
    { enabled: !!props.exportQuery && !!data && !(data as any)?.totalOutcome }
  )

  const { authState: gpAuth } = useContext(AuthContext)
  const groupPerms = usePermission(gpAuth?.user, String(props.name || "").replace(/ByFilter$/, ""))
  const leftButtons: JSX.Element[] = [
    <Button
      key="filter"
      size="large"
      className="table-action-btn"
      icon={<Search key="search" />}
      onClick={() => query.set("filtering", "true")}
    >
      {t("filter")}
    </Button>,
  ]
  // useEffect(() => {
  //   if (!query.has(title)) {
  //     refetch();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [query.get(title)]);

  useEffect(() => {
    if (error) {
      message.error(String(error))
    }
  }, [error])

  //   useEffect(() => {
  //     return () => {
  //       stopPolling()
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [])

  useEffect(() => {
    if (!query.has("begin") && !props.disableDefaultWeeklyFilter) {
      // Tog'a #438: sukut — «Сегодня» (avval joriy hafta edi)
      const { begin, end } = periodInterval(props.defaultPeriod || "today")
      query.append({
        begin,
        end,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout className={`${props.name}-page`}>
      <SEO title={t(props.name)} />
      <TableExtended
        hasFilter={!!props.filterComponent}   // s44: standart Фильтр oynasi ikki marta chiqmasin (sahifa o'z oynasini beradi)
        filterMatcher="filtering"   // s45: GroupedPage filtr oynasi matcher="filtering" (title — forma oynasi!)
        isDefective={props?.isDefective}
        name={title}
        titleName={props.name}
        pageName={title}   // tog'a #4147/#4152: sahifalash — usePagination(title) bilan bir xil kalit
        loading={loading}
        refetch={refetch}
        loadingAllData={loadingAllData}
        refetchAllData={refetchAllData}
        allData={allData?.data}
        dataSource={data?.data?.map((node: any, i: number) => ({
          ...node,
          key: i,
        }))}
        columns={props.columns}
        hideImport
        hideDelete
        pageInfo={data}
        onSort={(sort) =>
          query.setObj(title + "orderBy", { [sort.field]: sort.order })
        }
        {...props.tableProps}
        // Boshliq «Menejer huquqlari» (2026-09-14): guruhlangan ro'yxatda ham Добавить faqat yaratish huquqi bo'lsa (Page bilan bir xil)
        hideAdd={props.tableProps?.hideAdd || !groupPerms.canCreate}
        leftButtons={
          props.filterComponent
            ? [...leftButtons, ...(props.tableProps?.leftButtons || [])]
            : [...(props.tableProps?.leftButtons || [])]
        }
      />
      {/* {props.drawerChild && (
        <Drawer
          removeParamsOnClose={["id"]}
          matcher={title}
          title={drawerTitle}
          {...props.drawerProps}>
          {props.drawerChild}
        </Drawer>
      )} */}

      {props.filterComponent && <props.filterComponent matcher="filtering" />}
    </Layout>
  )
}

export default React.memo(GroupedPage)
